import React, { useState, useEffect } from "react";
import { Row, Col, Button, Card, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Axios from "axios";
import DatePicker from "react-datepicker";
import Moment from "moment";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ControllerStyles from "../styles/controller";

function Controller() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [type, setType] = useState("invoice");
  const [statements, setStatments] = useState([]);

  useEffect(() => {
    dispatch(GS_navSettingsActions.UpdateTitle("Online Payments"));
    dispatch(GS_navSettingsActions.UpdateSelected("Features"));
    dispatch(GS_navSettingsActions.UpdateSubSelected("Online Payments"));

    getStatements(type);
  }, []);

  const [detailsModal, setDetailsModal] = useState({
    open: false,
    statement: {},
    items: [],
    view: "text",
    fileName: "",
    loading: false,
    producing: false,
    showBtns: true,
  });

  function handleCloseDetailsModal() {
    setDetailsModal((prevState) => {
      return { ...prevState, open: false };
    });
  }

  const [dateModal, setDateModal] = useState({
    open: false,
    date: new Date(),
  });

  function handleDateModalClose() {
    setDateModal((prevState) => {
      return { ...prevState, open: false };
    });

    setDetailsModal((prevState) => {
      return { ...prevState, producing: false, showBtns: true };
    });
  }

  const [modal, setModal] = useState({
    open: false,
    header: "",
    message: "",
  });

  function handleCloseModal() {
    setModal({ open: false, header: "", message: "" });
  }

  function changeTab(tab) {
    setType(tab);
    getStatements(tab);
  }

  function getStatements(type) {
    const data = { type: type };
    Axios.post("/pods/onlinePayments/getStatements", data)
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          setStatments(data.statements);
        }
      })
      .catch((err) => console.log(err));
  }

  function handleProduceAnInvoice() {
    navigate("./produceInvoice");
  }

  function handleProduceAReceipt() {
    navigate("./produceReceipt");
  }

  function handleMore() {
    navigate("./moreSettings");
  }

  function handleOpenDetailsModal(statement) {
    const data = { ref: statement.ref };
    Axios.post("/pods/onlinePayments/getStatementItems", data)
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          for (const item of data.items) {
            item.total = item.unitPrice * item.quantity;
          }

          setDetailsModal((prevState) => {
            return {
              ...prevState,
              view: "text",
              open: true,
              statement: statement,
              items: data.items,
            };
          });
        }
      })
      .catch((err) => console.log(err));
  }

  function handleViewAsPDF(ref) {
    setDetailsModal((prevState) => {
      return { ...prevState, loading: true, showBtns: false };
    });

    const data = { ref: ref, type: type };
    Axios.post("/pods/onlinepayments/makeStatmentPDF", data)
      .then((res) => {
        const data = res.data;
        console.log(data);
        if (data.error == "null") {
          setDetailsModal((prevState) => {
            return {
              ...prevState,
              fileName: data.filename,
              view: "pdf",
              loading: false,
              showBtns: true,
            };
          });
        }
      })
      .catch((err) => console.log(err));
  }

  function handleViewAsText() {
    setDetailsModal((prevState) => {
      return { ...prevState, view: "text" };
    });
  }

  function pdfLoaded(filename) {
    const data = { filename: filename };

    Axios.post("/pods/onlinePayments/deleteTempPDF", data)
      .then((res) => {
        const data = res.data;
      })
      .catch((err) => console.log(err));
  }

  function handleOpenDateModal() {
    setDetailsModal((prevState) => {
      return { ...prevState, producing: true, showBtns: false };
    });
    setDateModal((prevState) => {
      return { ...prevState, date: new Date(), open: true };
    });
  }

  function handleProduceAReceiptFromInvoice() {
    setDateModal((prevState) => {
      return { ...prevState, open: false };
    });

    const data = {
      invRef: detailsModal.statement.ref,
      date: Moment(dateModal.date).format("DD/MM/YYYY"),
    };

    Axios.post("/pods/onlinePayments/produceReceiptFromInvoice", data)
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          const timer = setTimeout(() => {
            const secondData = { filename: data.filename };

            Axios.post("/pods/onlinePayments/deleteTempPDF", secondData)
              .then((res) => {
                const secondData = res.data;
                setDetailsModal((prevState) => {
                  return {
                    ...prevState,
                    producing: false,
                    showBtns: true,
                    statement: data.statement,
                  };
                });
                setModal({
                  header: "Receipt Created!",
                  message: data.message,
                  open: true,
                });
              })
              .catch((err) => console.log(err));
            // console.log("here");
          }, 2000);
        }
      })
      .catch((err) => console.log(err));
  }

  function handleDateChange(date) {
    setDateModal((prevState) => {
      return { ...prevState, date: date };
    });
  }

  return (
    <div style={ControllerStyles.body}>
      <Row>
        <Col>
          <Button onClick={handleProduceAnInvoice}>Produce an Invoice</Button>
          <Button onClick={handleProduceAReceipt}>Produce a Receipt</Button>
        </Col>
        <Col style={ControllerStyles.topButtons}>
          <Button onClick={handleMore}>More...</Button>
        </Col>
      </Row>
      <Row>
        <Col
          style={
            type == "invoice"
              ? ControllerStyles.tabSelectedText
              : ControllerStyles.tabText
          }
          onClick={changeTab.bind(this, "invoice")}
        >
          Invoices
        </Col>
        <Col
          style={
            type == "receipt"
              ? ControllerStyles.tabSelectedText
              : ControllerStyles.tabText
          }
          onClick={changeTab.bind(this, "receipt")}
        >
          Receipts
        </Col>
      </Row>
      <Row>
        <Col style={ControllerStyles.headings}>
          <Card style={ControllerStyles.cardHeadingsStyle}>
            <Card.Body>
              <Row>
                <Col>Ref.</Col>
                <Col>Name</Col>
                <Col>Email</Col>
                <Col>Total</Col>
                <Col>Date</Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col style={ControllerStyles.statementBody}>
          {statements.length > 0 ? (
            <div>
              {statements.map((statement, index) => {
                return (
                  <div key={index}>
                    <Card
                      style={ControllerStyles.cardStyle}
                      onClick={handleOpenDetailsModal.bind(this, statement)}
                    >
                      <Card.Body>
                        <Row>
                          <Col>{statement.ref}</Col>
                          <Col>{statement.customer}</Col>
                          <Col>{statement.email}</Col>
                          <Col>£{statement.total}</Col>
                          <Col>{statement.date}</Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <br />
                  </div>
                );
              })}
            </div>
          ) : (
            <div>You have no statements</div>
          )}
        </Col>
      </Row>
      <Modal
        size={"lg"}
        show={detailsModal.open}
        onHide={handleCloseDetailsModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {type.charAt(0).toUpperCase() + type.slice(1)} Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={ControllerStyles.topEmailMessage}>
            This {type} was sent to {detailsModal.statement.email}
            <hr />
          </div>
          {detailsModal.view == "text" ? (
            <div>
              <div style={ControllerStyles.previewTopDetails}>
                <strong>Ref:</strong> {detailsModal.statement.ref} <br />
                <strong>Date:</strong> {detailsModal.statement.date}
              </div>
              <div>
                <strong>Name:</strong> {detailsModal.statement.customer} <br />{" "}
                <br />
                <strong>Items:</strong>
              </div>
              <div>
                <Row>
                  <Col
                    sm={4}
                    style={ControllerStyles.previewItemHeaderBordersStart}
                  >
                    <strong>Item</strong>
                  </Col>
                  <Col style={ControllerStyles.previewItemHeaderBorders}>
                    <strong>Unit Price</strong>
                  </Col>
                  <Col style={ControllerStyles.previewItemHeaderBorders}>
                    <strong>Quantity</strong>
                  </Col>
                  <Col style={ControllerStyles.previewItemHeaderBorders}>
                    <strong>Total</strong>
                  </Col>
                </Row>
                {detailsModal.items.map((item, index) => {
                  return (
                    <div key={index}>
                      <Row>
                        <Col
                          sm={4}
                          style={ControllerStyles.previewItemBordersStart}
                        >
                          {item.item}
                        </Col>
                        <Col style={ControllerStyles.previewItemBorders}>
                          £{parseFloat(item.unitPrice).toFixed(2)}
                        </Col>
                        <Col style={ControllerStyles.previewItemBorders}>
                          {item.quantity}
                        </Col>
                        <Col style={ControllerStyles.previewItemBorders}>
                          £{parseFloat(item.total).toFixed(2)}
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </div>
              <br />
              <div style={ControllerStyles.previewTotal}>
                <strong>Total: £{detailsModal.statement.total}</strong>
              </div>
            </div>
          ) : null}
          {detailsModal.view == "pdf" ? (
            <div>
              <iframe
                id="iframepdf"
                width="100%"
                height="500"
                src={`${window.location.origin}/content/temp/${detailsModal.fileName}`}
                onLoad={pdfLoaded.bind(this, detailsModal.fileName)}
              ></iframe>
            </div>
          ) : null}
          <hr />
          <Row>
            <Col>
              {type == "invoice" && (
                <div>
                  {detailsModal.statement.receiptRef != "" ? (
                    <div>Receipt Ref: {detailsModal.statement.receiptRef}</div>
                  ) : (
                    <div>
                      {detailsModal.producing ? (
                        <div style={ControllerStyles.pdfLodingSign}>
                          Producing...
                        </div>
                      ) : (
                        <div>
                          {detailsModal.showBtns && (
                            <div>
                              <Button onClick={handleOpenDateModal}>
                                Produce Receipt
                              </Button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Col>
            <Col style={ControllerStyles.rightBtns}>
              {detailsModal.loading ? (
                <div style={ControllerStyles.pdfLodingSign}>Loading...</div>
              ) : (
                <div>
                  {detailsModal.view == "text" && detailsModal.showBtns && (
                    <Button
                      variant="primary"
                      onClick={handleViewAsPDF.bind(
                        this,
                        detailsModal.statement.ref
                      )}
                    >
                      View As PDF
                    </Button>
                  )}
                  {detailsModal.view == "pdf" && detailsModal.showBtns && (
                    <Button variant="primary" onClick={handleViewAsText}>
                      View As Text
                    </Button>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal show={dateModal.open} onHide={handleDateModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Reciept Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Select a date for the receipt: &ensp;
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={dateModal.date}
            onChange={(date: Date) => handleDateChange(date)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleProduceAReceiptFromInvoice}>
            Produce Reciept
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modal.open} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modal.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.message}</Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Controller;
